import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/**
 * Add-New-Game card for the Event Admin page.
 * Purely presentational — receives the newGame state and callbacks from the parent.
 */
export const AddGameForm = ({ newGame, setNewGame, onAddGame }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>➕ Add New Game</CardTitle>
        <CardDescription>Manually add a game to the schedule</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <label className="text-sm font-medium">Game Type</label>
            <select
              value={newGame.season_type}
              onChange={(e) => setNewGame({ ...newGame, season_type: e.target.value, type: e.target.value })}
              className="mt-1 w-full p-2 rounded bg-background border border-border"
            >
              <option value="preseason">Preseason</option>
              <option value="regular">Regular Season</option>
              <option value="playoff">Playoff</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium">Date</label>
            <Input
              type="date"
              value={newGame.date}
              onChange={(e) => setNewGame({ ...newGame, date: e.target.value })}
              className="mt-1"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Time (CT)</label>
            <Input
              value={newGame.timeCT}
              onChange={(e) => setNewGame({ ...newGame, timeCT: e.target.value })}
              className="mt-1"
              placeholder="7:30 PM"
            />
          </div>
          <div className="md:col-span-2">
            <label className="text-sm font-medium">Opponent</label>
            <Input
              value={newGame.opponent}
              onChange={(e) => setNewGame({ ...newGame, opponent: e.target.value })}
              className="mt-1"
              placeholder="San Antonio Spurs"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Note</label>
            <Input
              value={newGame.note}
              onChange={(e) => setNewGame({ ...newGame, note: e.target.value })}
              className="mt-1"
              placeholder="Optional note"
            />
          </div>
        </div>
        <Button onClick={onAddGame} className="w-full">Add Game</Button>
      </CardContent>
    </Card>
  );
};

export default AddGameForm;
